var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    rx: 72,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 38.12L37.532 64.095V79.939L23.017 105.863L23 38.12Z",
    fill: "#5B57A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.797 54.643L92.414 46.297L120.282 46.271L78.797 71.685V54.643Z",
    fill: "#D90751"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.72 37.967L78.797 72.357L64.231 63.407V12L78.721 37.967H78.72Z",
    fill: "#FAB718"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.282 46.271L92.413 46.297L78.72 37.967L64.231 12L120.281 46.271H120.282Z",
    fill: "#ED6F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.797 106.007V89.322L64.231 80.542L64.239 132L78.797 106.007Z",
    fill: "#63B22F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.38 97.737L37.531 64.095L23 38.12L120.223 97.703L92.379 97.737H92.38Z",
    fill: "#1487C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.24 132L78.796 106.007L92.379 97.737L120.222 97.703L64.24 132Z",
    fill: "#017F36"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.017 105.863L64.35 80.543L50.454 72.017L37.532 79.939L23.017 105.863Z",
    fill: "#984995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSbp);
export default __webpack_public_path__ + "static/media/logo-sbp.9f4575a40349ac52c9a438b962b5770c.svg";
export { ForwardRef as ReactComponent };